import styled from 'styled-components';
import { color, typography } from 'styled-system';
import FONT_URL_WOFF2 from './fontello.woff2';
import FONT_URL_WOFF from './fontello.woff';
import FONT_URL_TTF from './fontello.ttf';
import FONT_URL_EOT from './fontello.eot';
import { ICON_NAME_MAP } from '../constants/iconNames';

export const Icon = styled.i`
  ${color};
  ${typography};
  display: inline-block;
  width: ${props => props.fontSize}px;
  height: ${props => props.fontSize}px;
  text-align: center;
  vertical-align: text-bottom;
  font-family: 'fontello';
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  @font-face {
    font-family: 'fontello';
    font-style: normal;
    font-weight: 400;
    src: url(${FONT_URL_WOFF2}) format('woff2'),
       url(${FONT_URL_WOFF}) format('woff'),
       url(${FONT_URL_TTF}) format('ttf'),
       url(${FONT_URL_EOT}) format('eot');
  }

  &::before {
    content: "${props => ICON_NAME_MAP[(props.name || '').toUpperCase()]}";
    display: inline-block;
  }
`;

Icon.defaultProps = {
  fontSize: 'icon',
  color: 'icon',
};
